import React from "react";

import { Container } from "./Chat.styles";
import { FiMessageSquare } from "react-icons/fi";

const Chat = () => {
  return (
    <Container>
      <FiMessageSquare />
    </Container>
  );
};

export default Chat;
